import moment from "moment";
import types from "./types";
import _ from "lodash";

const defaultValues = {
  title: "Observation Report",
  data: [],
  start: moment().year(1970),
  end: moment(),
  first: moment(),
  observationAreas: [],
  observers: [],
  fetched: false,
  error: null,
};

export default function reducer(state = defaultValues, action) {
  switch (action.type) {
  case types.FETCH_OBSERVATIONS: {
    if (!state.fetched) {
      action.payload.start = moment(action.payload.metadata.firstDate);
    }
    const observationAreas = _.sortedUniq(
      _.sortBy(_.union(_.map(action.payload.observations, "obsArea"), action.payload.metadata.observationAreas))
    );
    const observers = _.sortedUniq(
      _.sortBy(_.union(_.map(action.payload.observations, "obsName"), action.payload.metadata.observers))
    );
    return {
      ...state,
      title: action.payload.metadata.title,
      data: action.payload.observations,
      start: action.payload.start,
      end: action.payload.end,
      first: moment(action.payload.metadata.firstDate),
      observationAreas,
      observers,
      fetched: true,
    };
  }

  case types.FETCH_OBSERVATIONS_ERROR: {
    return {
      ...state,
      error: action.payload.response,
    };
  }

  case types.FETCH_OBSERVATIONS_CLEAR: {
    return defaultValues;
  }

  default: {
    return state;
  }
  }
}



// WEBPACK FOOTER //
// ./src/redux/observations/reducers.js